import Swiper from 'swiper/bundle';

const classPrefix = 'main-specialist-video'
const dataPrefix = 'data-main-specialist-video'

export function mainSpecialistVideo($container, videos) {
    const $specialistVideoTemplate = document.querySelector(`[${dataPrefix}-container-template]`)
    init();

    function init() {
        videos.forEach((video, index) => {
            initCard(video, index)
        })
    }

    function initCard(video, index) {
        console.log(video)
        const $videoCardClone = document.importNode($specialistVideoTemplate.content, true);

        const $videoContainer = $videoCardClone.querySelector(`[${dataPrefix}-container]`)
        const $videoTitle = $videoCardClone.querySelector(`[${dataPrefix}-title]`)
        const $videoDescription = $videoCardClone.querySelector(`[${dataPrefix}-description]`)
        const $videoPreviewImageBack = $videoCardClone.querySelector(`[${dataPrefix}-preview-img-back]`)
        const $videoPreviewImage = $videoCardClone.querySelector(`[${dataPrefix}-preview-img]`)
        const $videoPreviewInfo = $videoCardClone.querySelector(`[${dataPrefix}-preview-info]`)
        const $videoTagList = $videoCardClone.querySelector(`[${dataPrefix}-tag-list]`)


        $videoContainer.href = `/video/${video.id}`
        $videoTitle.innerText = video.title;
        $videoDescription.innerText = video.description;
        $videoPreviewImage.src = `/storage/videos/${video.id}/${video.video_preview}`
        $videoPreviewImageBack.src = `/storage/videos/${video.id}/${video.video_preview}`

        //TODO: Переделать на подсчёт правильных ответов

        if (video.responded_question > 0)
        {
            if (video.responded_question == video.total_question)
            {
                $videoPreviewInfo.innerText = `${video.responded_question} из ${video.total_question}`
                $videoPreviewInfo.classList.add(`${classPrefix}__preview-info--active`)

            }
            else {
                $videoPreviewInfo.innerText = `${video.responded_question} из ${video.total_question}`
            }

        }
        else{
            $videoPreviewInfo.innerText = getMinuteForm(video.duration)
        }


        //console.log(video)

        video.tags.forEach(tag => {
            const $tag = document.createElement('div');
            $tag.classList.add(`${classPrefix}__info-list-item`)
            $tag.innerText = tag.name
            $videoTagList.appendChild($tag)
        })

        // Создаём обёртку swiper-slide
        const $swiperSlide = document.createElement('div');
        $swiperSlide.classList.add('swiper-slide');

        $swiperSlide.appendChild($videoCardClone);
        $container.appendChild($swiperSlide);
    }



}

export function getMinuteForm(minuteCount) {
    if (minuteCount % 10 === 1 && minuteCount % 100 !== 11) {
        return minuteCount + " минута";
    } else if (minuteCount % 10 >= 2 && minuteCount % 10 <= 4 && (minuteCount % 100 < 10 || minuteCount % 100 >= 20)) {
        return minuteCount + " минуты";
    } else {
        return minuteCount + " минут";
    }
}


